import React from 'react'
import { Form, FormGroup } from 'reactstrap'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { NoteRequestBase } from '../../api/note'
import { validators } from '../../utils'
import Textarea from './Textarea'

interface MixupNoteFormProps {
  onSubmit(x: NoteRequestBase): void
}

function MixupNoteFormInternal({
  handleSubmit,
  onSubmit,
  submitting,
}: MixupNoteFormProps & InjectedFormProps<NoteRequestBase, MixupNoteFormProps>) {
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Field name="body" component={Textarea} rows={5} label="Message" validate={[validators.required]} />
      <FormGroup>
        <button type="submit" disabled={submitting}>
          Submit
        </button>
      </FormGroup>
    </Form>
  )
}

export const MixupNoteForm = reduxForm<NoteRequestBase, MixupNoteFormProps>({})(MixupNoteFormInternal)
